class ReadMoreMobile extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return [
      'data-read-more-mobile-short-content-visible',
      'data-read-more-mobile-translation-read-more',
      'data-read-more-mobile-translation-read-less',
    ]
  }

  static get requiredElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    if (!event.target.closest(this.els.trigger.selector)) return
    const shortContentVisible =
      this.dataset.readMoreMobileShortContentVisible === 'true'
    this.setAttribute(
      'data-read-more-mobile-short-content-visible',
      String(!shortContentVisible),
    )

    this.els.trigger.element.textContent = !shortContentVisible
      ? this.dataset.readMoreMobileTranslationReadMore
      : this.dataset.readMoreMobileTranslationReadLess

    if (shortContentVisible) {
      this.dispatchEvent(
        new CustomEvent('READ_MORE::READ_MORE', {
          bubbles: true,
          detail: { event },
        }),
      )
    } else {
      this.dispatchEvent(
        new CustomEvent('READ_MORE::READ_LESS', {
          bubbles: true,
          detail: { event },
        }),
      )
    }
  }
}

if (!customElements.get('read-more-mobile')) {
  customElements.define('read-more-mobile', ReadMoreMobile)
}
